import type { OTCDealData } from '@src/types/OTC';
import { useMarketAccountsContext } from '@talos/kyoko';
import { InspectorText } from '../InspectorText';
import { MarketAccountDisplay } from '../MarketAccountDisplay';
import type { DisplayOutputItem } from './types';

export const useCounterpartyInformation = (instrumentData: OTCDealData): DisplayOutputItem => {
  const { marketAccountsByName } = useMarketAccountsContext();

  return {
    sectionTitle: 'Counterparty Information',
    fields: [
      {
        fieldName: 'Counterparty',
        fieldValue: <InspectorText>{instrumentData.Counterparty}</InspectorText>,
      },
      {
        fieldName: 'Sub Account',
        fieldValue: <InspectorText>{instrumentData.SubAccount}</InspectorText>,
      },
      {
        fieldName: 'Market Account',
        fieldValue: (
          <MarketAccountDisplay
            marketAccount={instrumentData.MarketAccount}
            marketAccountsByName={marketAccountsByName}
          />
        ),
      },
    ],
  };
};
